const de = {
  deliveryApp: 'LieferApp',
  name: 'Vorname',
  userName: 'Nutzername',
  lastName: 'Nachname',
  telephoneNr:'Telefonnummer',
  finish: 'Fertig',
  finished: 'Fertig',
  delete: 'Löschen',
  bockPickUp: 'Bock abholen',
  bockBarcodeError: 'Barcode-Länge ist nicht in Ordnung !',
  bockCode: 'Bock code',
  bock: 'Bock',
  street: 'Straße',
  zipCodePlace: 'PLZ/Ort',
  number: 'Nummer',
  bockNumber: 'Bock nummer',
  deliveryDate: 'Lieferdatum',
  deliveryTime: 'Lieferzeit',
  delivery: 'Anlieferung',
  scannedItems: 'Gescannte Artikel',
  bockDelete: 'Bock löschen',
  bockDeleteMessage: 'Bist du sicher ?',
  yes: 'Ja',
  no: 'Nein',
  orderFinish: 'Auftrag fertig',
  orderNumber: 'Auftragsnummer',
  bockList: 'Bock Liste',
  emptyList: 'Die Liste ist leer',
  onTheTruck: 'Auf dem LKW',
  atTheCustomer: 'Beim Kunden',
  loadingPlace: 'Verladeplatz',
  loadingStatus: 'Verlade status',  
  position: 'Position',  
  positions: 'Positionen',
  positionNotFound: 'Für diese Bestellung wurden keine Positionen gefunden',
  commission: 'Kommission',
  settings: 'Einstellungen',
  settingsMessage: 'Info: Sie benötigen eine Internetverbindung, um die Einstellungen zu erhalten.',
  customer: 'Kunde',
  customerSpecifics: 'Kundenspezifikationen',
  driverNotes: 'Fahrernotizen',
  warehouseAddress: 'Lageradresse',
  assemblers: 'Monteure',
  noAssemblers: 'Assembler nicht gefunden',
  sync: 'Sync',
  syncProgress: 'Synchronisierung läuft',
  backup: 'Sicherungskopie',
  sign: 'unterzeichnen',    
  customerSignature: 'Unterschrift des Kunde',
  driverSignature: 'Unterschrift des Fahrer',
  signDocument: 'Dokument unterschreiben',
  signedDocument: 'Dokument unterschrieben',
  saveDocument: 'Dokument speichern',
  saveDocumentForAll: `Speichern Sie Dokumente für alle heutigen Bestellungen dieser Firma`,
  piece: 'Stück',
  width: 'Breite',
  height: 'Höhe',
  comment: 'Kommentar',
  partially: 'Teilweise',
  synchronize: 'Synchronisieren',
  dbLoading:'Laden der Datenbank',
  stop: 'Stop',
  deletePhoto: 'Foto löschen ?',
  cancel: 'abbrechen',
  confirm: 'Bestätigen',
  confirmAuftragMessage0: `Alle Positionen werden überprüft, aber der Auftragsstatus lautet "Teilweise". Sind Sie sicher, dass Sie fortfahren möchten?`,
  confirmAuftragMessage1: `Nicht alle Positionen sind abgehakt, aber der Bestellstatus lautet "Fertig". Sind Sie sicher, dass Sie fortfahren möchten?`,
  confirmAuftragMessage2: 'Bist du dir sicher, dass du weitermachen willst ?',
  confirmSelected: 'Ausgewählte Positionen bestätigen?',
  company: 'Firma',
  none:'keiner',
  save: 'speichern',
  takePhoto: 'Foto machen',
  syncFailMessage: 'Synchronisation nicht erfolgreich! Bitte versuch es später!',
  driverList: 'Fahrerliste',
  punkt1: 'Warenanlieferung pünktlich (inerhalb 30 Min.?)',
  punkt2: 'Warenanlieferung vollständig ?',
  punkt3: 'Warenanlieferung sichtbar beschädigt ?',
  EkName: "Ek Name",
  start: "Start",
  end: "Ende",
  clientNotAtHome: "Kunde nicht vor Ort",
  mehrTagesTour: "Mehrtages-Tour",
  tagesTour:"Tages-Tour",
  signatureEmpty:"Es müssen beide Unterschriften vorhanden sein oder Kunde nicht vor Ort muss ausgewählt werden",
  cusromerAdress: "Anschrift Kunde",
  deliveryAdress: "Lieferadresse"
  };
  
  export default de;